<div class="casino-pt">
    <div class="sports-book">
        <iframe class="embed-responsive-item" scrolling="yes" [src]='iframeUrl | safeURL' allowfullscreen="true" title="game" id="casino-link"></iframe>
    </div>
</div>